var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47.5,
    fill: "#DEEAFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 48,
    height: 48,
    fill: "url(#pattern0_336_2504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_336_2504",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_336_2504",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_336_2504",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAACkElEQVR4nO2a227TQBCG96aPAAgoiHOvSDubSDwPNDtpH6sgJAotlHIoPAEH9RUQzUwACSgUaLnITdAkNioHZ53dTUjIfJJv1vbMenY8tv+xMYqiKIqiFAHXmiesoxvW8SeL3AncPgPyzfkGnTQeakutOet4Cxx/D/XXO5ceV+qtSyaGy3WeBaQPERf+28ToYxXfnO578Uj7qfxZR98WGnwxOADW0Xp34shPasvNc6F2KvWds7IivUnxRrE/3sqOubVw9e2RUH9yLiDdzoL+KNSOAeQ9MVJbbp0ykVRx53hvZWi/2B8dyDExF59TWXp31OfPCyC3xUgVt2dMAvLUDN2f2p8XDQBqBrT1FkCtAZ3DRdAivwSk54drxQBjk18E7V+MxowlnXBqe6AB4D8yABy/AKRnvwSq5Nh/kQExaABQM6CjtwBqDeiE1ojUNcfL1H8OW6S1TBB5Cot0wQQiYkoudgDyvaLjctEEkFblez5KC3B0J7P1MNSOEQ3PIr1PKYn1E1dEwxMZa2wksZ9KjqMVQN4Nn4gIqnRdBFbjQSYsMlauDgUFGulAVj4maxVFURTFGCOPkujH0gC9urHqDVaxeR6Qvo7qxWQce4ObPWO0FvNqmvXqVn29urHtDUKJN7iyvTq5lUbZG+znz4tKYqiaYFvSSEVRVFV4xiQgfzyF7k/tbyJqwDB7kZMSgKRjAwEaAP7nGTDMXuREZMAw/XnRAKBmQFtvAZzuGrAnBsr85e3jyuKrY2V/lY3RHgbx50X6eFkU78cEQfQEQL6bqTSbxf7oQXbMeowGUdafl/nG6zN5FqTYwPGXfn+dd/XHhBKcz1/pIHRXJCIQcq5kk/w2X7KTvDEqf4qiKIpippcfVL3Oe4SLsQIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxIcon);
export default __webpack_public_path__ + "static/media/uxIcon.be92705c32661f7ed2434485f1bbad2c.svg";
export { ForwardRef as ReactComponent };